module.exports = __webpack_public_path__ + "img/14.5cc582ce.png";